<div class="upsell-guarantee">
  <div class="upsell-guarantee__container mx-auto p-4">
    <div class="upsell-guarantee__row flex items-center gap-8 justify-center" [ngClass]="showImage ? 'flex-col desktop:flex-row' : 'flex-col'">
      <div class="upsell-guarantee__content w-full desktop:w-2/3" [ngClass]="{'w-full' : !showImage }">
        <div class="upsell-guarantee__buttons flex flex-col gap-4">
          <button 
            data-qa="cta-yes" 
            class="upsell-guarantee__button-yes w-full overflow-visible text-center font-bold text-white rounded-sm transition-transform text-xl leading-6 p-2.5 active:translate-y-0.5"
            [ngClass]="upsellCtaTextButtonsClass"
            (click)="nextPage(true)" 
            data-te="cta-yes" 
            [innerHTML]="buttonYesText"  
            title="YES I WANT THIS SPECIAL ADDED TO MY ORDER">
            YES I WANT THIS SPECIAL ADDED TO MY ORDER
          </button>

          <button 
            data-qa="cta-no" 
            class="upsell-guarantee__button-no w-full overflow-visible text-center font-semibold rounded-sm transition-transform p-2.5 active:translate-y-0.5"
            [ngClass]="upsellCtaTextButtonsClass"
            (click)="nextPage(false)" 
            [innerHTML]="buttonNoText" 
            data-te="cta-no">
          </button>
          
          <p 
            class="upsell-guarantee__description text-lg text-gray-800"
            [ngClass]="{'hidden' : !showDescription }">
            {{ description }}
          </p>
        </div>
      </div>
      
      <div class="upsell-guarantee__image w-full desktop:w-1/3 text-center">
        <img class="mx-auto" src="{{ image }}" alt="{{ imageAlt }}">
      </div>
    </div>
  </div>
</div>
